import Decimal from 'decimal.js';
import { fromDatestampObject } from "./time";
import { utils } from "../utils";
import { numberAndUnit } from "../infra/utils";
import { isSameDay, startOfMonth } from 'date-fns';
import { getLastXMonths } from "../utils/date.utils";
export let SalesSummaryStatus = /*#__PURE__*/function (SalesSummaryStatus) {
  SalesSummaryStatus["Sent"] = "sent";
  SalesSummaryStatus["Approved"] = "approved";
  SalesSummaryStatus["Terminated"] = "terminated";
  SalesSummaryStatus["Canceled"] = "canceled";
  SalesSummaryStatus["Reviewed"] = "reviewed";
  return SalesSummaryStatus;
}({});
export class SalesSummaryModel {
  static fromDTO(dto, now) {
    const items = dto.calendar.map(SalesSummaryModel.itemFromDTO);
    return new SalesSummaryModel({
      numProposalsSentThisYear: new Decimal(dto.numProposalsSentThisYear),
      medianTimeToSign: new Decimal(dto.medianTimeToSign),
      calendar: fillLast12Months(items, now)
    });
  }
  static itemFromDTO(dto) {
    return {
      date: fromDatestampObject(dto.date),
      statuses: makeFullStatuses(dto.statuses)
    };
  }
  constructor(data) {
    this.data = data;
  }
  isEmpty() {
    return this.data.numProposalsSentThisYear.isZero();
  }
  formattedNumProposalsSentThisYear() {
    return utils.formatNumberWithCommas(this.data.numProposalsSentThisYear);
  }
  formattedMedianTimeToSign() {
    return this.isEmpty() ? 'Not available' : numberAndUnit(this.data.medianTimeToSign.toNumber(), 'Day');
  }
  calendar() {
    return this.data.calendar;
  }
}
function fillLast12Months(data, now) {
  return getLastXMonths(now, 12).map(date => {
    const asFirstOfMonth = startOfMonth(date);
    return data.find(item => isSameDay(asFirstOfMonth, startOfMonth(item.date))) || {
      date,
      statuses: makeFullStatuses({})
    };
  });
}
function makeFullStatuses(statuses) {
  return {
    [SalesSummaryStatus.Sent]: makeStatusValue(statuses[SalesSummaryStatus.Sent]),
    [SalesSummaryStatus.Approved]: makeStatusValue(statuses[SalesSummaryStatus.Approved]),
    [SalesSummaryStatus.Terminated]: makeStatusValue(statuses[SalesSummaryStatus.Terminated]),
    [SalesSummaryStatus.Canceled]: makeStatusValue(statuses[SalesSummaryStatus.Canceled]),
    [SalesSummaryStatus.Reviewed]: makeStatusValue(statuses[SalesSummaryStatus.Reviewed])
  };
}
function makeStatusValue(dto) {
  return {
    total: new Decimal(dto ? dto.total : 0)
  };
}